import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledBodyFinalInterview = styled.div`
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
`;

export const StyledDevelopmentQuadrantContainer = styled.div<{
  $isFirst?: boolean;
  $isLast?: boolean;
  $bordered: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: ${(props) => props.$bordered && "40px"};
  align-items: center;
  padding: 14px 20px;
  box-sizing: border-box;
  border: ${(props) =>
    props.$bordered ? `1px solid ${theme.colors.purple_2}` : "none"};
  border-bottom: ${(props) =>
    props.$bordered
      ? props.$isLast
        ? `1px solid ${theme.colors.purple_2}`
        : "none"
      : "none"};
  border-radius: ${(props) =>
    props.$bordered
      ? props.$isFirst
        ? "8px 8px 0 0"
        : props.$isLast
          ? "0 0 8px 8px"
          : "none"
      : "none"};
`;

export const StyledColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid ${theme.colors.purple_2};
  border-radius: 8px;
`;

export const StyledColumn = styled.div<{
  $canViewDevelopmentScreen: boolean;
}>`
  display: flex;
  flex-direction: column;
  border-bottom: ${(props) =>
    props.$canViewDevelopmentScreen
      ? `1px solid ${theme.colors.purple_2}`
      : "none"};
  justify-content: center;
  box-sizing: border-box;
  margin-top: ${(props) => (props.$canViewDevelopmentScreen ? "60px" : "20px")};
  margin-bottom: 20px;
  height: ${(props) => (props.$canViewDevelopmentScreen ? "420px" : "unset")};
`;

export const StyledFinalInterviewInfo = styled.div<{
  $withBackground?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 100%;
  background-color: ${(props) =>
    props.$withBackground ? theme.colors.purple_4 : "none"};
  border-radius: 8px;
  padding: ${(props) => (props.$withBackground ? "20px" : "unset")};
  box-sizing: border-box;
  margin-bottom: 20px;
  text-align: center;

  & .final-interview-label-container {
    display: flex;
    background-color: ${theme.colors.purple_2};
    padding: 5px 10px;
    border-radius: 8px;
    width: fit-content;
  }

  & .final-interview-label-container.icon {
    padding: 10px;
  }
`;
